
import { Component, signal, inject } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FuelTotalDecreaseFullModal } from '../fuel-total-decrease-full-modal/fuel-total-decrease-full-modal.component';
import { ChartData, GroupedBarChartComponent } from '../../../../_shared';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-fuel-consumption-breakdown',
  standalone: true,
  imports: [GroupedBarChartComponent, TranslocoDirective], //
  templateUrl: './fuel-consumption-breakdown.component.html',
  styleUrl: './fuel-consumption-breakdown.component.scss',
})
export class FuelConsumptionBreakdown {
  private readonly modalRef = inject(NgbActiveModal);
  private readonly modalService = inject(NgbModal);

  protected fullChart = signal<boolean>(false);
  protected totalDecreaseData = ChartData.totalDecrease;

  protected fullChartClick(): void {
    // this.dialog.open(FuelTotalDecreaseFullModal, {
    //   panelClass: ['fuelGraphModal'],
    // });

    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    };
    const modalRef = this.modalService.open(FuelTotalDecreaseFullModal, modalOptions);
  }

  protected closeModal(): void {
    this.modalRef.close();
  }
}
